import script from "./BiddingActionsDonation.vue?vue&type=script&setup=true&lang=js"
export * from "./BiddingActionsDonation.vue?vue&type=script&setup=true&lang=js"

import "./BiddingActionsDonation.vue?vue&type=style&index=0&id=05047663&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05047663"]])

export default __exports__